// Truncate (never round up) money values, same as web2's parseFloatCustom.
export function money(value, digits = 2) {
  const n = parseFloat(value);
  if (!isFinite(n)) return (0).toFixed(digits);
  const factor = Math.pow(10, digits);
  return (Math.trunc(n * factor) / factor).toLocaleString('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function signed(value, digits = 2) {
  const n = parseFloat(value) || 0;
  return (n >= 0 ? '+' : '-') + money(Math.abs(n), digits);
}
